module.exports = __webpack_public_path__ + "img/longaetera.80289574.png";